import React, {memo} from "react";
import CustomButton from "../../components/CustomButton";


const Step5 = ({clearAll, redirectToServices}) => (
    <div className="registration-for-service__step-5 step-5">
        <h4 className="step-5__title">Ваша запись на услугу успешно зарегистрирована!</h4>
        <CustomButton onClick={clearAll}>Ок</CustomButton>
        <CustomButton onClick={redirectToServices}>Перейти в мои записи</CustomButton>
    </div>
);

export default memo(Step5);